import React from "react";
import { Link } from "react-router-dom";
import { Container } from "./Primitives";
import { TRUST_ITEMS } from "./TrustStrip";

/** Light-theme trust strip shown at the top of shop routes. Reads the same
 *  four claims from `TrustStrip.TRUST_ITEMS` so the wording, item set and
 *  ordering match the HeroTrust exactly — one source of truth (defect D7). */
export function TrustBar() {
  return (
    <div className="border-b border-rule bg-surface" data-testid="trust-bar">
      <Container className="no-scrollbar flex gap-6 overflow-x-auto py-3 sm:justify-between">
        {TRUST_ITEMS.map(({ icon: Icon, top, to }) => (
          <Link
            key={top}
            to={to}
            className="ui flex shrink-0 items-center gap-2 text-[11px] text-dim transition-colors hover:text-gold sm:text-xs"
          >
            <Icon className="h-3.5 w-3.5 text-verify" aria-hidden="true" />
            {top}
          </Link>
        ))}
      </Container>
    </div>
  );
}
